function random(seed) {
  var _seed = seed % 2147483647;

  if (_seed <= 0) _seed += 2147483646;
  return {
    next: function next() {
      _seed = _seed * 16807 % 2147483647;
      return _seed;
    }
  };
} // random :: https://gist.github.com/blixt/f17b47c62508be59987b#file-prng-js


var _letter = function _letter(x) {
  return "trwagmyfpdxbnjzsqvhlcke"[+x % 23];
};

var _randStrLimit = function _randStrLimit(limit) {
  return "".concat(Math.random()).slice(-limit);
};

var _randFloat = function _randFloat(seed) {
  return (random(seed).next() - 1) / 2147483646;
};

export { _letter, _randStrLimit, _randFloat };